import React from "react";
import ContentRight from "./ContentRight";
import ContentLeft from "./ContentLeft";

const CardContainer = ({ heading, item, totalvehiclecount }) => {
  if (totalvehiclecount === 0) {
    return (
      <div className="text-center mt-10 text-lg font-semibold text-red-500">
        Data not available for this ARN
      </div>
    );
  }
  return (
    <div className="w-full mt-3">
      <p className="text-sm bg-[#056DB3] p-1 text-center text-white sm:w-full">
        {item.heading}
      </p>

      <div className="mt-5 flex flex-col gap-2 md:block">
        <ContentRight
          parValue={item.parvalue}
          heading={item.heading}
          paricon={item.paricon}
          parentbadge={item.parentbadge}
          childbadge={item.childbadgela}
          className=""
        />

        <div className="flex text-xs text-gray-700">
          <div class="hidden md:block w-[2px] h-12 bg-[#056DB3] ml-32"></div>
          <p className="ml-2"> {item.Parheading}</p>
        </div>
        <ContentLeft
          parValue={item.childval1}
          paricon={item.childicon1}
          childval1a={item.childval1a}
          parentbadge={item.childbadge1}
          childbadge={item.childbadge1a}
          className="mb-0 "
        />
        <div className="flex text-xs text-gray-700 w-full">
          <p className="ml-2 text-wrap w-[40%]">{item.childtitle1}</p>
          <div class="hidden md:block w-[2px] h-12 bg-[#056DB3] ml-6"></div>
        </div>
        <ContentRight
          parValue={item.childval2}
          paricon={item.childicon2}
          childval1a={item.childval2a}
          childval2={item.childval2}
          parentbadge={item.childbadge2}
          childbadge1a={item.childbadge2a}
          className="mt-0"
        />
        <div class="flex justify-end items-end">
          {" "}
          <p className="flex text-wrap w-[50%] items-end justify-end text-xs text-gray-700">
            {item.childtitle2}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardContainer;
